import React from 'react';
import { useNavigate } from 'react-router-dom';
import CustomBootstrapTable from 'utils/reactTable';
import { FiPaperclip } from 'react-icons/fi';
import { GoEye } from 'react-icons/go';

const DepensesTable = ({ data, handleRowClick = () => {}, selectedRows, onSelectRow }) => {
  const navigate = useNavigate();
  const rowEvents = {
    onClick: (e, row) => {
      console.log('Table row clicked:', row); // Check if this logs
      handleRowClick(row);
    },
  };
  const sortedData = React.useMemo(() => {
    return data.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
  }, [data]);
  const columns = [
    {
      dataField: 'id',
      text: 'N°',
      formatter: (cell, row, rowIndex) => (
        <div onClick={() => handleRowClick(row)}>{row.piece_journal || rowIndex + 1}</div>
      ),
    },
    {
      dataField: 'fournisseurs_details',
      text: 'Fournisseur',
      formatter: (cell, row) => (
        <div onClick={() => handleRowClick(row)}>{cell?.nom}</div>
      ),
    },
    {
      // dataField: 'dossier_id',
      text: 'Fait par',
      formatter: (cell, row) => (
        <div className="styleColonne" onClick={() => handleRowClick(row)}>
          {row.created_by_details?.first_name || 'N/A'}
        </div>
      ),
    },
    {
      dataField: 'updated_at',
      text: 'Date',
      formatter: (cell, row) => {
        // Priorite a la date de transaction (date Odoo), fallback updated_at
        const rawDate = row.date_transaction || cell;
        const date = new Date(rawDate);

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        if (row.date_transaction) {
          return <div onClick={() => handleRowClick(row)}>{`${day}/${month}/${year}`}</div>;
        }

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return <div onClick={() => handleRowClick(row)}>{`${day}/${month}/${year} à ${hours}:${minutes}`}</div>;
      },
    },
    {
      dataField: 'statut_paiement',
      text: 'Statut',
      formatter: (cell, row) => {
        const statusMap = {
          PAYE: { label: 'Payé', color: '#065f46', bg: '#d1fae5' },
          PARTIEL: { label: 'Partiel', color: '#92400e', bg: '#fef3c7' },
          NON_PAYE: { label: 'Non payé', color: '#991b1b', bg: '#fee2e2' },
          RETARD: { label: 'En retard', color: '#7f1d1d', bg: '#fecaca' },
        };
        const status = statusMap[cell] || { label: cell || (row.archived ? 'Archivé' : 'Activé'), color: '#374151', bg: '#f3f4f6' };
        return (
          <div
            onClick={() => handleRowClick(row)}
            style={{
              color: status.color,
              backgroundColor: status.bg,
              padding: '2px 8px',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: 600,
              display: 'inline-block',
            }}
          >
            {status.label}
          </div>
        );
      },
    },
    {
      dataField: 'prix',
      text: 'Prix',
      formatter: (cell, row) => {
        // Somme des lignes produit si presentes, sinon le prix de la sortie
        // (mode migration Odoo : pas de lignes produit, prix direct)
        const Price = row?.produits_associes?.length
          ? row.produits_associes.reduce(
              (sum, prod) => sum + parseFloat(prod.prix || 0),
              0
            )
          : (row?.prix ?? row?.montant_total ?? 0);
        return (
          <div onClick={() => handleRowClick(row)}>{Number(Price).toFixed(2)}</div>
        );
      },
    },
    {
      dataField: 'quantite',
      text: 'Qte',
      formatter: (cell, row) => {
        const Quantity = row?.produits_associes?.reduce(
          (sum, prod) => sum + (parseInt(prod.quantite, 10) || 0),
          0
        );
        return <div onClick={() => handleRowClick(row)}>{Quantity}</div>;
      },
    },

    {
      dataField: 'taxes',
      text: 'Taxes',
      formatter: (cell, row) => (
        <div onClick={() => handleRowClick(row)}>{cell}</div>
      ),
    },
    {
      dataField: 'piece_joint',
      text: <FiPaperclip />,
      formatter: (cell, row) => {
        const fileUrl = row.piece_comptable_details?.fileUrl || row.piece_comptable_details?.fichier || cell || row.justificatif_file;
        return (
          <div className="styleColonne" onClick={() => handleRowClick(row)}>
            {fileUrl ? (
              <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#009688', fontWeight: 600 }}>
                📎 Pièce jointe
              </a>
            ) : (
              <span style={{ color: '#94a3b8' }}>:</span>
            )}
          </div>
        );
      },
    },
    {
      dataField: 'montant_total',
      text: 'Total',
      formatter: (cell, row) => (
        <div onClick={() => handleRowClick(row)}>{cell} Fcfa</div>
      ),
    },
    {
      dataField: 'action',
      text: 'Action',
      formatter: (cell, row) => (
        <GoEye
          title="Voir le détail"
          style={{ cursor: 'pointer', color: '#009688', fontSize: '18px' }}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`detailDepense/${row.id}`);
          }}
        />
      ),
    },
  ];

  return (
    <CustomBootstrapTable
      keyField="id"
      data={sortedData}
      columns={columns}
      rowEvents={rowEvents}
      selectedRows={selectedRows} // Forward the prop
      onSelectRow={onSelectRow} // Forward the prop
    />
  );
};

export default DepensesTable;
